import { Link } from 'react-router-dom';
import { ROUTES } from '../Routes';
import { useState } from 'react';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  };

  return (
    <header>
      <nav>
        <div className="logo">🎰 noravo.site</div>
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`} id="navLinks">
          <li><Link to={ROUTES.BASE}>HOME</Link></li>
          <li><Link to={ROUTES.GAMES}>GAMES</Link></li>
          <li><Link to={ROUTES.ABOUT}>ABOUT</Link></li>
          <li><Link to={ROUTES.CONTACT}>CONTACT</Link></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;